import { createSelector } from 'reselect'
import { get } from 'lodash'

const assessors = (assessors, props) => ({ list: assessors.list, props })


const mapForDropdown = data => {
  const intl = get(data, 'props.intl')

  let list = get(data, 'list') || []

   list = list.map(item => ({
    value: item.id,
    label: get(item, 'isPublicAvailable') ? get(item, 'person.name') :
        intl.formatMessage({ id: 'label.did_not_consent_to_assess_others',
          defaultMessage: '{name} (did not consent to assess other participants)' }, { name: get(item, 'person.name') }),
     disabled: get(item, 'isPublicAvailable') ? false : true
  }))

  const noneOfThese = { value: 0, label: intl.formatMessage({
          id: 'label.add_my_assessor',
          defaultMessage: 'Add my Assessor'
      }) }

  list.unshift(noneOfThese)

  return list
}

export default createSelector(assessors, mapForDropdown)
